// extracted by mini-css-extract-plugin
export default {"chartNoData":"markets__chartNoData__fPqkvW","fadeinWrap":"markets__fadeinWrap__fdK_wK","fadeIn":"markets__fadeIn__VokzZd","swipeTip":"markets__swipeTip__mDAzXe"};